<template>
  <div>
    <div class="ie-header">
      <div class="title">
        <span>Internet Explorer Support</span>
      </div>
    </div>
    <div class="ie-content">
        <ie-warning/>
    </div>
  </div>
</template>
<script>
import IeWarning from "@/components/support/IEWarning.vue";
export default {
  components: { IeWarning },
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables.scss";

.ie-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  background-color: $gray-800;
  color: $text-inverted;

  & > .title {
    font-size: 2rem;
    margin-left: 10px;
  }
}

.ie-content {
    padding: 20px;
}
</style>